import { Block, BlockGrid } from '../../types';

export function blockGridToBlockList(blockGrid: BlockGrid): Block[] {
  let blocks: Block[] = [];
  for (let row of blockGrid) {
    blocks = [...blocks, ...row];
  }
  return blocks;
}
